import { component } from 'common/util/ComponentDecorator';

@component
export default class product {
	static classname = 'products-calc';

	constructor($calc) {
		this.$calc = $calc;
		this.minHeight = 90;
		this.maxHeight = 3000;
		this.error = false;
		this.heightVal = null;
		this.$calcHTML = null;

		this.init();
	}

	init() {
		this.saveCalcStepHtml();
		this.initEventListener();
	}

	saveCalcStepHtml() {
		this.$calcHTML = this.$calc.html();
	}

	initEventListener() {
		const that = this;
		this.$calc.on('input change', '.products-calc__input', function (e) {
			that.handleHeightInput($(this).val(), e.type === 'change');
		});

		this.$calc.on('click', '.products-calc__calc-btn', function () {
			that.calc();
		});

		this.$calc.on('set_value:quantity', '.products-calc__quantity', function () {
			var quantityValue = $(this).find('.products-calc__quantity-input').val();

			that.updateQuantityProp(quantityValue);
		});

		this.$calc.on('click', '.products-calc__back', function () {
			that.updateBlock(that.$calcHTML);
		});

		this.$calc.on('click', '.products-calc__close', function () {
			ModalUtil.close();
		});
	}

	setHeightError(isError = false) {
		this.error = isError;
		this.$calc.find('.products-calc__formgroup').toggleClass('products-calc__formgroup--error', this.error);
	}

	toggleCalcBtn () {
		const toActivate = !this.error && this.heightVal;
		this.$calc.find('.products-calc__calc-btn').toggleClass('btn--disabled', !toActivate);
	}

	handleHeightInput(val, checkMin) {
		let value = val;
		if (val < this.minHeight && checkMin) {
			value = val * 100;
		}

		this.setHeightError(val > this.maxHeight);

		if (!this.error) {
			this.heightVal = value >= this.minHeight ? value : null;
			this.$calc.find('.products-calc__input').val(value);
			this.$calc.find('.products-calc__height-value').text(value);
		}
		this.toggleCalcBtn();
	}

	updateQuantityProp(quantity) {
		this.$calc.find('.products-calc__add2cart').data('quantity', quantity);
	}

	calc() {
		const that = this;
		that.$calc.addClass('products-calc--loading');
		$.ajax({
			url: '?products-calc=1',
			type: 'POST',
			data: {tree_height: this.heightVal},
			dataType: 'json'
		}).always(res => {
			const $newBlock = $(res.responseText).find('.products-calc');
			that.updateBlock($newBlock.html());
			that.$calc.removeClass('products-calc--loading');
		});
	}

	updateBlock($newBlock) {
		this.$calc.html($newBlock);

		Update(this.$calc);
	}
}
